import { useInfiniteQuery } from '@tanstack/react-query';
import { concat, isEmpty } from 'lodash';
import { generateQuery, queryKeys, requestCCApi } from 'src/utils';

import { mapPublicationWithIncludes } from './helper';

export const useGetBulkReplaceRequests = (
  filters: string[] = [],
  includes: string[] = [],
) => {
  return useInfiniteQuery(
    queryKeys.bulkReplaceRequests.pagination(filters),
    ({ pageParam = 1 }) =>
      fetchBulkReplaceRequests(pageParam, filters, includes),
    {
      enabled: !isEmpty(filters),
      staleTime: Infinity,
      getNextPageParam: (lastPage, allPages) => {
        const currentPage = lastPage ? allPages.length : 1;
        const totalPages = lastPage ? lastPage?.totalPages : 1;

        return currentPage < totalPages ? currentPage + 1 : undefined;
      },
    },
  );
};

export const fetchBulkReplaceRequests = async (
  page: number,
  filters: string[],
  includes: string[],
  fetchAll?: boolean,
) => {
  const queryFilters = concat(filters, [
    `count=true`,
    `page=${page}`,
    fetchAll ? 'pageSize=100' : 'pageSize=20',
  ]);

  const response = await requestCCApi({
    url: `/bulkReplaceRequests${generateQuery(
      includes.length > 0 ? includes : [],
      queryFilters,
    )}`,
  });

  return mapPublicationWithIncludes(response, includes);
};
